import React from "react";
import { useForm, useStep } from "react-hooks-helper";
import { HaveYouReceived } from "./stepForm/HaveYouReceived";
import { IsCalcon } from "./stepForm/IsCalcon";
import { FirstAnswer } from "./stepForm/FirstAnswer";
import { SecondAnswer_YES } from "./stepForm/SecondAnswer_YES";
import { SecondAnswer_NO } from "./stepForm/SecondAnswer_NO";
import { SecondAnswer_NOTSURE } from "./stepForm/SecondAnswer_NOTSURE";

const defaultData = {
  primaryBorrowerFirstName: "",
  primaryBorrowerLastName: "",
  refinanceGoals: "",
  loanReason: "",
  remainingBalance: "",
  whenAreYouLooking: "",
  describeYourCredit: "",
  homeValue: "",
  phone: "",
  email: "",
  city: "",
  state: "",
  propertyUse: "",
  generalContractor: "",
  downPayment: "",
  purchasePrice: "",
  projectBudget: "",
  ownLotOfLand: "",
};

const steps = [
  { id: "HaveYouReceived" },
  { id: "IsCalcon" },
  { id: "firstAnswer" },
  { id: "SecondAnswer_YES" },
  { id: "SecondAnswer_NO" },
  { id: "SecondAnswer_NOTSURE" },
];

export const MultiStepForm = () => {
  const [formData, setForm] = useForm(defaultData);
  const { step, navigation } = useStep({
    steps,
    initialStep: 0,
  });

  // console.log(formData);

  const props = { formData, setForm, navigation, useStep, step };

  switch (step.id) {
    case "HaveYouReceived":
      return <HaveYouReceived {...props} />;
    case "firstAnswer":
      return <FirstAnswer {...props} />;
    case "IsCalcon":
      return <IsCalcon {...props} />;
    case "SecondAnswer_YES":
      return <SecondAnswer_YES {...props} />;
    case "SecondAnswer_NO":
      return <SecondAnswer_NO {...props} />;
    case "SecondAnswer_NOTSURE":
      return <SecondAnswer_NOTSURE {...props} />;
  }

  return (
    <div>
      <h1>OneTrust Home Loans</h1>
    </div>
  );
};
